import {
    useStyles,
    pxToRem,
    Button,
    Image,
    useDeviceTypeContext,
} from '@archipro-design/aria';
import * as S from './APConnectBanner.style';
import { ArrowRightLine } from '@archipro-design/icons';
import { SliderButton } from '@typeform/embed-react';
import {
    AP_CONNECT_BANNER_DESCRIPTION,
    AP_CONNECT_BANNER_TITLE,
    AP_CONNECT_TYPEFORM_ID,
    BANNER_IMAGE_FILE_ADDRESS_COMBINED_PATH,
    CATEGORY_IMAGE_COMBINED,
} from './constants';
import { useRef } from 'react';
import { useCountryContext } from '@archipro-website/localisation';

import { getImagesSizes } from '~/utils/image-sizes-utils';
import { useConfigContext } from '@archipro-website/config/bindings/react';
import { useImpression, useTracker } from '@archipro-website/tracker';

const APConnectBanner = () => {
    const { css } = useStyles();
    const config = useConfigContext();
    const { desktop } = useDeviceTypeContext();
    const { code } = useCountryContext();
    const bannerRef = useRef(null);
    const tracking = useTracker();

    const sliderRef = useRef<{ open?: () => void }>();

    const openSlider = () => {
        sliderRef.current?.open?.();
        tracking.log('apConnectButtonClick', {
            url: new URL(window.location.href),
            targetTracker: 'archiproTracker',
        });
    };

    useImpression({
        ref: bannerRef,
        onImpression: async (url: URL) => {
            tracking.log('apConnectBannerView', {
                url: url,
                targetTracker: 'archiproTracker',
            });
        },
    });

    return (
        <div className={css(S.APConnectbannerContainer)} ref={bannerRef}>
            <div className={css(S.ConnectBannerLeft)}>
                <div className={css(S.BannerTitle)}>
                    {AP_CONNECT_BANNER_TITLE}
                </div>
                <div className={css(S.BannerDescription)}>
                    {AP_CONNECT_BANNER_DESCRIPTION}
                </div>
                <Button
                    className={css(S.TypeformButton)}
                    iconAfter={
                        <ArrowRightLine
                            variables={{
                                '1xSize': pxToRem(20),
                            }}
                        />
                    }
                    onClick={() => openSlider()}
                >
                    Get Matched
                </Button>

                <SliderButton
                    ref={sliderRef}
                    hidden={{ country: code.toLowerCase() }}
                    id={AP_CONNECT_TYPEFORM_ID}
                    buttonProps={{
                        className: css(S.SliderButtonHidden),
                    }}
                >
                    getmatched
                </SliderButton>
            </div>
            <div className={css(S.RightSection)}>
                <Image
                    loading={'eager'}
                    src={
                        config.assetsBaseUrl +
                        BANNER_IMAGE_FILE_ADDRESS_COMBINED_PATH +
                        CATEGORY_IMAGE_COMBINED
                    }
                    width={pxToRem(desktop ? 852 : 491, 1)}
                    height={pxToRem(desktop ? 281 : 262, 1)}
                    sizes={getImagesSizes(desktop ? 852 : 491)}
                    objectFit={desktop ? 'cover' : 'fill'}
                    alt="Archipro Connect Profile Image"
                />
            </div>
        </div>
    );
};

export default APConnectBanner;
